export default "__VITE_ASSET__x2r6YO2i__"